enum OperationStatusEnum {
	SUCCESS = 'SUCCESS',
	FAILURE = 'FAILURE',
}

export default OperationStatusEnum;
